import { Link } from 'react-router-dom';
import LegalLayout from '@/components/LegalLayout';
import { BUSINESS } from '@/lib/legal';

export default function PaymentTerms() {
  return (
    <LegalLayout
      title="Payment & Subscription Terms"
      intro={`How payments, plan activation, top-ups, and expiry work at ${BUSINESS.brand}.`}
    >
      <h2>Payment methods</h2>
      <p>
        We accept credit and debit cards, and Apple Pay where available. All card payments are processed securely
        by <strong>Square</strong>. Your card details go directly to Square — {BUSINESS.brand} never stores your
        card number or security code. You may also pay in store.
      </p>

      <h2>When your plan becomes active</h2>
      <ul>
        <li><strong>Pay online:</strong> your plan activates as soon as Square confirms the payment.</li>
        <li><strong>Pay in store:</strong> your plan stays pending until our staff confirm your payment, then it activates.</li>
      </ul>

      <h2>Prepaid, not auto-renewing</h2>
      <p>
        Each plan is a one-time prepaid purchase of tiffin credits valid for a set number of days. We do{' '}
        <strong>not</strong> automatically renew plans or charge your card again. When your credits or validity run
        out, you decide whether to buy again.
      </p>

      <h2>Top-ups</h2>
      <p>
        You can top up an active subscription with more credits at any time. Top-up payments follow the same rules
        and are applied to your balance once the payment is confirmed.
      </p>

      <h2>Currency &amp; taxes</h2>
      <p>
        Prices are in Canadian Dollars (CAD). Applicable taxes, if any, are shown or included at checkout as
        required by law.
      </p>

      <h2>Expiry of credits</h2>
      <p>
        Credits are valid only during the plan's validity period. Unused credits expire when the period ends and
        are not carried over unless we say otherwise.
      </p>

      <h2>Refunds &amp; disputes</h2>
      <p>
        Refunds are handled per our <Link to="/refunds">Refund &amp; Cancellation Policy</Link> and issued through
        Square. If you have a billing question, contact{' '}
        <a href={`mailto:${BUSINESS.supportEmail}`}>{BUSINESS.supportEmail}</a> before opening a card dispute so we
        can resolve it quickly.
      </p>
    </LegalLayout>
  );
}
